import { render, staticRenderFns } from "./mySample.vue?vue&type=template&id=6d952fa4&scoped=true&"
import script from "./mySample.vue?vue&type=script&lang=js&"
export * from "./mySample.vue?vue&type=script&lang=js&"
import style0 from "./mySample.vue?vue&type=style&index=0&id=6d952fa4&lang=scss&scoped=true&"
import style1 from "./mySample.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d952fa4",
  null
  
)

export default component.exports